import {
    UPDATE_CURRENT_URL,
    DELETE_CURREMT_URL,
} from '../constants/currentUrlConstants';

const initialState = {
    loading: false,
    success: false,
    error: '',
    type: '',
    loadingTitle: '',
    loadingMessage: '',
    currentUrlData: undefined,
};

function currentUrlReducer(state = initialState, action) {
    switch (action.type) {
        case UPDATE_CURRENT_URL:

            const oldPath = (state && state.currentLocationData && state.currentLocationData.pathname)? state.currentLocationData.pathname: undefined;
            const newPath = (action && action.data && action.data.pathname)? action.data.pathname: undefined;

            if(!newPath || newPath.length === 0  || (oldPath === newPath && (!action.returnToHome ||  action.returnToHome === state.returnToHome) ))  return state;

            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': '',
                'type': action.type,
                'currentLocationData':action.data,
                'returnToHome': (action && action.returnToHome)?action.returnToHome : state.returnToHome,
            });
        case DELETE_CURREMT_URL:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type,
                'currentLocationData':undefined
            });
        default:
            return state;
    }
};

export default currentUrlReducer